import React, {Component} from 'react';


function encode(data) {
  return Object.keys(data).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&');
}

class ContactForm extends Component {

  state = {
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
    how_did_you_hear_about_us: '',
    page: '',
  }

  componentDidMount() {
    this.setState({ page: window.location.pathname })
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = e => {
    e.preventDefault()

    if (!this.refs.form.checkValidity()) return false

    fetch("https://hooks.zapier.com/hooks/catch/3298056/221zudl/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": this.refs.form.getAttribute("name"),
        ...this.state
      })
    })
      .then(() => this.setState({result: 'success'}))
      .catch(error => this.setState({result: 'fail', msg: error}))
  }

  render() {
    let props = {
      ref: 'form',
      name: 'contact',
      className: 'form',
      onSubmit: this.handleSubmit
    };
    if (this.state.result === 'success') {
      return (
        <div className='form__row'>
          <p>Thanks for enquiring. A member of the team will be in touch soon.</p>
        </div>
      )
    }
    return (
      <form {...props}>
        <div className="form__row form__row--double">
          <input
            type="text"
            name="name"
            placeholder="Name"
            onChange={this.handleChange}
            required
          />
          <input
            type="text"
            name="company"
            placeholder="Company"
            onChange={this.handleChange}
            required
          />
        </div>
        <div className="form__row form__row--double">
          <input
            type="email"
            name="email"
            placeholder="Email"
            onChange={this.handleChange}
            required
          />
          <input
            type="text"
            name="phone"
            placeholder="Contact Number"
            onChange={this.handleChange}
            required
          />
        </div>
        <div className="form__row form__row--double">
          <div className='form__select'>
            <select name="budget" onChange={this.handleChange}>
              <option value="">Budget</option>
              <option value="$10k+">$10k+</option>
              <option value="$20k+">$20k+</option>
              <option value="$50k+">$50k+</option>
              <option value="$70k+">$70k+</option>
              <option value="$90k">$90k+</option>
            </select>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 9L12 15L18 9" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <input
            type="text"
            name="how_did_you_hear_about_us"
            placeholder="How did you hear about us?"
            onChange={this.handleChange}
            required
          />
        </div>
        <div className="form__row">
          <textarea name="message" placeholder="Tell us a bit about your project." onChange={this.handleChange}></textarea>
        </div>
        <div className="form__row form__row--submit">
          <button 
            type="submit" className="btn"
            onMouseEnter={() => window?._handleMouseEnter('')}
            onMouseLeave={() => window?._handleMouseLeave()}
          >
            Contact Us
          </button>
        </div>
      </form>
    );
  }
}

export default ContactForm